import LanguageActionTypes from './language.types'

export const setLanguage = (value) => ({
  type: LanguageActionTypes.SET_LANGUAGE,
  payload: value,
})
